import React, { useState } from 'react';
import GlobalButton from '@/components/ui/GlobalButton';
import SuccessToast from '@/components/modals/SuccessToast';

interface ConfirmDeleteProps {
  onClose: () => void;
  onDelete: () => void;
  isDeleting: boolean;
  type: string;
}

export default function ConfirmDelete({
  onClose,
  onDelete,
  isDeleting,
  type,
}: ConfirmDeleteProps) {
  return (
    <div className="modal">
      <div
        onClick={(event) => {
          event.stopPropagation();
          onClose();
        }}
        className="modal-overlay absolute inset-0 bg-black-1/40 opacity-90"
      ></div>

      <div className="bg-modal-fill px-6 py-8 w-[90%] md:w-[90%] lg:w-[40%] 3xl:w-[60%] max-h-[90%] max-w-[600px] h-fit top-1/2 left-1/2 absolute transform -translate-x-1/2 -translate-y-1/2 flex flex-col gap-8 rounded-lg shadow-md text-text-primary-heading">
        <div className="flex flex-col gap-1 items-start text-left">
          <h1 className="font-bold text-xl 3xl:text-[22px] text-text-primary-heading">
            Delete {type}
          </h1>
          <p className="text-text-primary-body text-sm 3xl:text-base">
            Are you sure you want to delete this {type} from this project?
          </p>
        </div>

        <div className="flex gap-5 w-fit ml-auto">
          <div className="w-fit">
            <GlobalButton
              onClick={onClose}
              variant={'stroke'}
              state={'default'}
              size={'md'}
            >
              Cancel
            </GlobalButton>
          </div>

          <div className="w-fit">
            <GlobalButton
              onClick={(event) => {
                event.stopPropagation();
                onDelete();
              }}
              variant={'secondaryRed'}
              size={'md'}
              state={isDeleting ? 'inactive' : 'default'}
            >
              {isDeleting ? 'Deleting...' : `Delete ${type}`}
            </GlobalButton>
          </div>
        </div>
      </div>
    </div>
  );
}
